module.exports = __webpack_public_path__ + "img/ring_PEWAG_A8W.20d3e18a.png";